/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CourseRegistrationManagementFinancialViewModel } from "../types/CourseRegistrationManagementFinancialViewModel.ts";
import { courseRegistrationManagementFinancialDiscountViewModelSchema } from "./courseRegistrationManagementFinancialDiscountViewModelSchema.ts";

export const courseRegistrationManagementFinancialViewModelSchema = z.object({
  personFullName: z
    .string()
    .describe("Nome completo da pessoa vinculada à matrícula.")
    .nullish(),
  personEmail: z
    .string()
    .describe("E-mail da pessoa vinculada à matrícula.")
    .nullish(),
  courseName: z.string().describe("Nome do curso da matrícula.").nullish(),
  classStudentName: z
    .string()
    .describe("Nome da turma da matrícula.")
    .nullish(),
  registrationTaxExpirationDate: z
    .string()
    .datetime()
    .describe("Data de vencimento da taxa de matrícula. Opcional.")
    .nullish(),
  poloCanChangeRegistrationTax: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o polo tem permissão para alterar o vencimento da taxa de matrícula.",
      ),
  ),
  firstTuitionExpirationDate: z
    .string()
    .datetime()
    .describe("Data de vencimento da primeira mensalidade. Opcional.")
    .nullish(),
  poloCanChangeFirstTuition: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o polo tem permissão para alterar o vencimento da primeira mensalidade.",
      ),
  ),
  isPoloAllowedToChangeFinancial: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o polo tem permissão para alterar informações financeiras.",
      ),
  ),
  descriptionPaymentMethod: z
    .string()
    .describe("Descrição do método de pagamento utilizado.")
    .nullish(),
  paymentInCashOrInstallments: z
    .string()
    .describe("Indica se o pagamento é à vista ou parcelado.")
    .nullish(),
  isScholarshipHolder: z.optional(
    z.boolean().describe("Indica se o aluno é bolsista."),
  ),
  planTotalValue: z
    .number()
    .describe("Valor total do plano financeiro. Opcional.")
    .nullish(),
  numberParcels: z
    .number()
    .int()
    .describe("Número de parcelas do plano financeiro. Opcional.")
    .nullish(),
  planSummary: z
    .string()
    .describe("Resumo textual do plano financeiro. Opcional.")
    .nullish(),
  discounts: z
    .array(
      z.lazy(
        () => courseRegistrationManagementFinancialDiscountViewModelSchema,
      ),
    )
    .describe("Lista de descontos aplicados ao plano financeiro da matrícula.")
    .nullish(),
}) as unknown as ToZod<CourseRegistrationManagementFinancialViewModel>;
